import { ReactNode } from "react"

import { Box, Typography } from "@mui/material"

const RankedBarRow = ({
  rank,
  label,
  ratio,
  barColor,
  right,
  labelColor = "mockup.neutral0",
  labelWeight = 700,
}: {
  rank: number
  label: string
  ratio: number
  barColor: string
  right: ReactNode
  labelColor?: string
  labelWeight?: number
}) => (
  <Box
    component="li"
    sx={{
      display: "grid",
      gridTemplateColumns: {
        mobile: "24px minmax(0, 1fr) auto",
        tablet: "24px minmax(0, 160px) minmax(0, 1fr) auto",
      },
      gridTemplateAreas: {
        mobile: "\"rank label right\" \"bar bar bar\"",
        tablet: "\"rank label bar right\"",
      },
      alignItems: "center",
      columnGap: 2,
      rowGap: 0.5,
      py: 0.75,
    }}
  >
    <Box
      sx={{
        gridArea: "rank",
        width: 22,
        height: 22,
        borderRadius: "50%",
        bgcolor: "mockup.neutral95",
        display: "grid",
        placeItems: "center",
      }}
    >
      <Typography variant="body3" color="mockup.neutral10">
        {rank}
      </Typography>
    </Box>
    <Typography
      variant="body2"
      noWrap
      title={label}
      color={labelColor}
      sx={{ gridArea: "label", fontWeight: labelWeight }}
    >
      {label}
    </Typography>
    <Box
      aria-hidden
      sx={{
        gridArea: "bar",
        maxWidth: 530,
        height: 20,
        borderRadius: 10,
        bgcolor: "mockup.neutral95",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: `${Math.max(0, Math.min(1, ratio)) * 100}%`,
          height: "100%",
          borderRadius: 10,
          bgcolor: barColor,
        }}
      />
    </Box>
    <Box sx={{ gridArea: "right" }}>{right}</Box>
  </Box>
)

export default RankedBarRow
